import React, { useState } from 'react'
import Navigation from '../components/Navigation'
import Footer from '../components/Footer'

const GITHUB_SKILLS = 'https://github.com/whatsable/whatsapp-business-agent-skills'
const DOCS_AGENT_SKILLS_OVERVIEW =
  'https://docs.whatsable.app/guides/notifyer-system/agent-skills/overview'
const NOTIFYER_SIGNUP = '/#pricing'

const VIBE_AGENTS = [
  { agentId: 'openclaw', label: 'OpenClaw' },
  { agentId: 'cursor', label: 'Cursor' },
  { agentId: 'claude', label: 'Claude Code' },
  { agentId: 'copilot', label: 'GitHub Copilot' },
  { agentId: 'gemini', label: 'Gemini CLI' },
  { agentId: 'amp', label: 'Amp' },
  { agentId: 'roo', label: 'Roo Code' },
  { agentId: 'junie', label: 'Junie' },
  { agentId: 'openhands', label: 'OpenHands' },
]

const STEP3_CODE = `node skills/setup-notifyer/scripts/login.js \\
  --email you@example.com --password "YourPassword@1" \\
export NOTIFYER_API_TOKEN="eyJ..."`

// ─── Agent Icon ───────────────────────────────────────────────────────────────

function AgentIcon({ agentId }) {
  if (agentId === 'openclaw')
    return (
      <img
        src="/agents/openclaw-dark.svg"
        alt=""
        width="20"
        height="20"
        className="h-5 w-5 shrink-0 object-contain"
        loading="lazy"
      />
    )
  if (agentId === 'cursor')
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 128 128"
        className="h-5 w-5 shrink-0"
        aria-hidden="true"
      >
        <path fill="url(#vcCursorA)" d="m64 128l55.6-32L64 64L8.4 96Z" />
        <path fill="url(#vcCursorB)" d="M119.6 96V32L64 0v64Z" />
        <path fill="url(#vcCursorC)" d="M64 0L8.4 32v64L64 64Z" />
        <path fill="#555" d="M119.6 32L64 128V64Z" />
        <path d="M119.6 32L64 64L8.4 32Z" />
        <defs>
          <linearGradient
            id="vcCursorA"
            x1="11.925"
            x2="11.925"
            y1="12"
            y2="24"
            gradientTransform="translate(.4)scale(5.33333)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset=".16" stopOpacity="0.39" />
            <stop offset=".658" stopOpacity="0.8" />
          </linearGradient>
          <linearGradient
            id="vcCursorB"
            x1="22.35"
            x2="11.925"
            y1="6.037"
            y2="12.15"
            gradientTransform="translate(.4)scale(5.33333)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset=".182" stopOpacity="0.31" />
            <stop offset=".715" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="vcCursorC"
            x1="11.925"
            x2="1.5"
            y1="0"
            y2="18"
            gradientTransform="translate(.4)scale(5.33333)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopOpacity="0.6" />
            <stop offset=".667" stopOpacity="0.22" />
          </linearGradient>
        </defs>
      </svg>
    )
  if (agentId === 'claude')
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 256 257"
        className="h-5 w-5 shrink-0"
        aria-hidden="true"
      >
        <path
          fill="#d97757"
          d="m50.228 170.321l50.357-28.257l.843-2.463l-.843-1.361h-2.462l-8.426-.518l-28.775-.778l-24.952-1.037l-24.175-1.296l-6.092-1.297L0 125.796l.583-3.759l5.12-3.434l7.324.648l16.202 1.101l24.304 1.685l17.629 1.037l26.118 2.722h4.148l.583-1.685l-1.426-1.037l-1.101-1.037l-25.147-17.045l-27.22-18.017l-14.258-10.37l-7.713-5.25l-3.888-4.925l-1.685-10.758l7-7.713l9.397.649l2.398.648l9.527 7.323l20.35 15.75L94.817 91.9l3.889 3.24l1.555-1.102l.195-.777l-1.75-2.917l-14.453-26.118l-15.425-26.572l-6.87-11.018l-1.814-6.61c-.648-2.723-1.102-4.991-1.102-7.778l7.972-10.823L71.42 0l10.63 1.426l4.472 3.888l6.61 15.101l10.694 23.786l16.591 32.34l4.861 9.592l2.592 8.879l.973 2.722h1.685v-1.556l1.36-18.211l2.528-22.36l2.463-28.776l.843-8.1l4.018-9.722l7.971-5.25l6.222 2.981l5.12 7.324l-.713 4.73l-3.046 19.768l-5.962 30.98l-3.889 20.739h2.268l2.593-2.593l10.499-13.934l17.628-22.036l7.778-8.749l9.073-9.657l5.833-4.601h11.018l8.1 12.055l-3.628 12.443l-11.342 14.388l-9.398 12.184l-13.48 18.147l-8.426 14.518l.778 1.166l2.01-.194l30.46-6.481l16.462-2.982l19.637-3.37l8.88 4.148l.971 4.213l-3.5 8.62l-20.998 5.184l-24.628 4.926l-36.682 8.685l-.454.324l.519.648l16.526 1.555l7.065.389h17.304l32.21 2.398l8.426 5.574l5.055 6.805l-.843 5.184l-12.962 6.611l-17.498-4.148l-40.83-9.721l-14-3.5h-1.944v1.167l11.666 11.406l21.387 19.314l26.767 24.887l1.36 6.157l-3.434 4.86l-3.63-.518l-23.526-17.693l-9.073-7.972l-20.545-17.304h-1.36v1.814l4.73 6.935l25.017 37.59l1.296 11.536l-1.814 3.76l-6.481 2.268l-7.13-1.297l-14.647-20.544l-15.1-23.138l-12.185-20.739l-1.49.843l-7.194 77.448l-3.37 3.953l-7.778 2.981l-6.48-4.925l-3.436-7.972l3.435-15.749l4.148-20.544l3.37-16.333l3.046-20.285l1.815-6.74l-.13-.454l-1.49.194l-15.295 20.999l-23.267 31.433l-18.406 19.702l-4.407 1.75l-7.648-3.954l.713-7.064l4.277-6.286l25.47-32.405l15.36-20.092l9.917-11.6l-.065-1.686h-.583L44.07 198.125l-12.055 1.555l-5.185-4.86l.648-7.972l2.463-2.593l20.35-13.999z"
        />
      </svg>
    )
  if (agentId === 'copilot')
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 256 208"
        className="h-5 w-5 shrink-0"
        aria-hidden="true"
      >
        <path d="M205.28 31.36c14.096 14.88 20.016 35.2 22.512 63.68c6.626 0 12.805 1.47 16.976 7.152l7.792 10.56A17.55 17.55 0 0 1 256 123.2v28.688c-.008 3.704-1.843 7.315-4.832 9.504C215.885 187.222 172.35 208 128 208c-49.066 0-98.19-28.273-123.168-46.608c-2.989-2.189-4.825-5.8-4.832-9.504V123.2c0-3.776 1.2-7.424 3.424-10.464l7.792-10.544c4.173-5.657 10.38-7.152 16.992-7.152c2.496-28.48 8.4-48.8 22.512-63.68C77.331 3.165 112.567.06 127.552 0H128c14.72 0 50.4 2.88 77.28 31.36m-77.264 47.376c-3.04 0-6.544.176-10.272.544c-1.312 4.896-3.248 9.312-6.08 12.128c-11.2 11.2-24.704 12.928-31.936 12.928c-6.802 0-13.927-1.42-19.744-5.088c-5.502 1.808-10.786 4.415-11.136 10.912c-.586 12.28-.637 24.55-.688 36.824c-.026 6.16-.05 12.322-.144 18.488c.024 3.579 2.182 6.903 5.44 8.384C79.936 185.92 104.976 192 128.016 192c23.008 0 48.048-6.08 74.512-18.144c3.258-1.48 5.415-4.805 5.44-8.384c.317-18.418.062-36.912-.816-55.312h.016c-.342-6.534-5.648-9.098-11.168-10.912c-5.82 3.652-12.927 5.088-19.728 5.088c-7.232 0-20.72-1.728-31.936-12.928c-2.832-2.816-4.768-7.232-6.08-12.128a106 106 0 0 0-10.24-.544m-26.941 43.93c5.748 0 10.408 4.66 10.408 10.409v19.183c0 5.749-4.66 10.409-10.408 10.409s-10.408-4.66-10.408-10.409v-19.183c0-5.748 4.66-10.408 10.408-10.408m53.333 0c5.749 0 10.409 4.66 10.409 10.409v19.183c0 5.749-4.66 10.409-10.409 10.409c-5.748 0-10.408-4.66-10.408-10.409v-19.183c0-5.748 4.66-10.408 10.408-10.408M81.44 28.32c-11.2 1.12-20.64 4.8-25.44 9.92c-10.4 11.36-8.16 40.16-2.24 46.24c4.32 4.32 12.48 7.2 21.28 7.2c6.72 0 19.52-1.44 30.08-12.16c4.64-4.48 7.52-15.68 7.2-27.04c-.32-9.12-2.88-16.64-6.72-19.84c-4.16-3.68-13.6-5.28-24.16-4.32m68.96 4.32c-3.84 3.2-6.4 10.72-6.72 19.84c-.32 11.36 2.56 22.56 7.2 27.04c10.56 10.72 23.36 12.16 30.08 12.16c8.8 0 16.96-2.88 21.28-7.2c5.92-6.08 8.16-34.88-2.24-46.24c-4.8-5.12-14.24-8.8-25.44-9.92c-10.56-.96-20 .64-24.16 4.32M128 56c-2.56 0-5.6.16-8.96.48c.32 1.76.48 3.68.64 5.76c0 1.44 0 2.88-.16 4.48c3.2-.32 5.92-.32 8.48-.32s5.28 0 8.48.32c-.16-1.6-.16-3.04-.16-4.48c.16-2.08.32-4 .64-5.76c-3.36-.32-6.4-.48-8.96-.48" />
      </svg>
    )
  if (agentId === 'gemini')
    return (
      <img
        src="/geminicli-color.svg"
        alt=""
        width="20"
        height="20"
        className="h-5 w-5 shrink-0 object-contain"
        loading="lazy"
      />
    )
  if (agentId === 'amp')
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 281 124"
        fill="currentColor"
        className="h-4 w-auto shrink-0 text-[#1c2329]"
        aria-hidden="true"
      >
        <path d="M236.014 0C260.431 9.71106e-05 280.602 17.4115 280.603 44.7432C280.602 73.5337 260.065 94.1657 233.52 94.166C224.158 94.166 215.639 92.4222 208.63 88.4902C202.886 85.2698 198.203 80.6054 194.919 74.3379L188.115 121.822L187.946 123.016H174.214L174.448 121.423L191.772 2.49414H205.372L203.937 11.3369C212.143 3.86078 223.2 0.000153635 236.014 0ZM47.082 0.154297C56.4435 0.154297 65.0012 1.8991 72.0488 5.84863C77.8222 9.08305 82.5323 13.7713 85.8271 20.085L88.1201 3.69238L88.2861 2.49316H101.863L89.1611 90.6328L88.9873 91.8262H75.4092L76.7227 82.8555C68.5854 90.4564 57.3981 94.3231 44.5889 94.3232C20.1709 94.3232 0.000167223 76.9087 0 49.5771C0.000149745 20.7854 20.54 0.154871 47.082 0.154297ZM116.234 90.6357L116.061 91.8271H102.485L115.351 3.68555L115.521 2.49414H129.083L116.234 90.6357ZM140.673 90.6357L140.499 91.8271H126.924L139.789 3.68555L139.96 2.49414H153.521L140.673 90.6357ZM177.958 2.49414L165.108 90.6357L164.935 91.8271H151.36L164.225 3.68555L164.396 2.49414H177.958ZM48.4854 11.9844C27.8638 11.985 14.0133 28.3799 14.0127 48.9521C14.0127 57.7907 16.8094 66.1771 22.3145 72.334C27.7973 78.4657 36.0631 82.4932 47.2402 82.4932C67.8534 82.4925 81.7122 65.9487 81.7129 45.3682C81.7129 35.4076 78.2493 27.0792 72.4131 21.2441C66.5794 15.4088 58.2871 11.9844 48.4854 11.9844ZM233.362 11.8291C212.749 11.8297 198.89 28.3716 198.89 48.9521C198.89 58.9123 202.356 67.2403 208.189 73.0742C214.023 78.9107 222.315 82.3358 232.116 82.3359C252.738 82.3355 266.589 65.9407 266.59 45.3682C266.59 36.5296 263.795 28.1424 258.29 21.9863C252.807 15.8551 244.542 11.8291 233.362 11.8291Z" />
      </svg>
    )
  if (agentId === 'roo')
    return (
      <img
        src="/agents/roocode.svg"
        alt=""
        width="20"
        height="20"
        className="h-5 w-5 shrink-0 object-contain"
        loading="lazy"
      />
    )
  if (agentId === 'junie')
    return (
      <img
        src="/agents/junie-color.svg"
        alt=""
        width="20"
        height="20"
        className="h-5 w-5 shrink-0 object-contain"
        loading="lazy"
      />
    )
  if (agentId === 'openhands')
    return (
      <img
        src="/agents/openhands-color.svg"
        alt=""
        width="20"
        height="20"
        className="h-5 w-5 shrink-0 object-contain"
        loading="lazy"
      />
    )
  return null
}

function AgentChip({ agentId, label }) {
  return (
    <span className="inline-flex shrink-0 items-center gap-1.5 rounded-full border border-[#ececec] bg-white px-3.5 py-1.5 text-[13px] font-medium text-[#1c2329] shadow-[0px_1px_3px_rgba(0,0,0,0.06)]">
      <AgentIcon agentId={agentId} />
      {label}
    </span>
  )
}

// ─── Code Block ──────────────────────────────────────────────────────────────

function CodeBlock({ code }) {
  const [copied, setCopied] = useState(false)

  const handleCopy = () => {
    navigator.clipboard.writeText(code).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    })
  }

  return (
    <div className="overflow-hidden rounded-xl border border-slate-700/50 bg-slate-900 shadow-inner">
      <div className="flex items-center justify-between border-b border-slate-700/40 bg-slate-800/60 px-4 py-2">
        <div className="flex items-center gap-1.5" aria-hidden="true">
          <span className="h-2.5 w-2.5 rounded-full bg-red-400/60" />
          <span className="h-2.5 w-2.5 rounded-full bg-yellow-400/60" />
          <span className="h-2.5 w-2.5 rounded-full" style={{ background: 'rgba(1, 205, 116, 0.6)' }} />
        </div>
        <span className="font-mono text-[11px] text-slate-500">bash</span>
      </div>
      <div className="relative px-4 py-4 sm:px-5">
        <button
          type="button"
          onClick={handleCopy}
          className={`absolute top-3 right-3 z-10 flex items-center gap-1.5 rounded-md border px-2 py-1 text-[11px] font-medium transition-all duration-150 ${
            copied
              ? 'border-[#01cd74]/50 bg-slate-800 text-[#01cd74]'
              : 'border-slate-600/50 bg-slate-800 text-slate-400 hover:border-slate-500 hover:bg-slate-700 hover:text-white'
          }`}
          aria-label="Copy command"
        >
          {copied ? (
            <svg
              className="h-3.5 w-3.5 shrink-0"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          ) : (
            <svg
              className="h-3.5 w-3.5 shrink-0"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M7 9.667A2.667 2.667 0 0 1 9.667 7h8.666A2.667 2.667 0 0 1 21 9.667v8.666A2.667 2.667 0 0 1 18.333 21H9.667A2.667 2.667 0 0 1 7 18.333z" />
              <path d="M4.012 16.737A2 2 0 0 1 3 15V5c0-1.1.9-2 2-2h10c.75 0 1.158.385 1.5 1" />
            </svg>
          )}
          <span>{copied ? 'Copied!' : 'Copy'}</span>
        </button>
        <pre className="overflow-x-auto pr-20 font-mono text-sm leading-relaxed text-emerald-50/90">
          <code>{code}</code>
        </pre>
      </div>
    </div>
  )
}

// ─── Step Card ────────────────────────────────────────────────────────────────

function StepCard({ number, title, description, code, extra }) {
  return (
    <li className="list-none">
      <div className="overflow-hidden rounded-2xl border border-[#ececec] bg-white shadow-[0px_1px_3px_rgba(0,0,0,0.04)] transition duration-200 hover:border-[rgba(1,205,116,0.3)] hover:shadow-[0px_4px_12px_rgba(0,0,0,0.06)]">
        <div className="flex items-start gap-4 px-5 pt-5 pb-4 sm:px-6 sm:pt-6">
          <div
            className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-bold text-white shadow-sm"
            style={{ background: 'linear-gradient(135deg, #01cd74 0%, #00a85d 100%)', boxShadow: '0 1px 6px rgba(1,205,116,0.3)' }}
          >
            {number}
          </div>
          <div>
            <h3 className="text-[15px] font-semibold tracking-[-0.4px] text-[#1c2329]">{title}</h3>
            <p className="mt-0.5 text-[13px] leading-relaxed text-[#656f68]">{description}</p>
          </div>
        </div>
        <div className="space-y-3 px-5 pb-5 sm:px-6 sm:pb-6">
          <CodeBlock code={code} />
          {extra}
        </div>
      </div>
    </li>
  )
}

// ─── Capability Card ──────────────────────────────────────────────────────────

const CAPABILITY_ICONS = {
  workspace: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32" className="h-5 w-5 shrink-0" aria-hidden="true">
      <path fill="currentColor" d="M16 17v8H6v-8zm0-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2m11-9v5H17V6zm0-2H17a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2m0 13v5h-5v-5zm0-2h-5a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2M11 6v5H6V6zm0-2H6a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2" />
    </svg>
  ),
  broadcast: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="h-5 w-5 shrink-0" aria-hidden="true">
      <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
        <path d="M11 6a13 13 0 0 0 8.4-2.8A1 1 0 0 1 21 4v12a1 1 0 0 1-1.6.8A13 13 0 0 0 11 14H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z" />
        <path d="M6 14a12 12 0 0 0 2.4 7.2a2 2 0 0 0 3.2-2.4A8 8 0 0 1 10 14M8 6v8" />
      </g>
    </svg>
  ),
  livechat: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="h-5 w-5 shrink-0" aria-hidden="true">
      <path fill="currentColor" d="M12 21q-.425 0-.712-.288T11 20t.288-.712T12 19h7v-7.1q0-2.925-2.037-4.962T12 4.9T7.038 6.938T5 11.9V17q0 .425-.288.713T4 18q-.825 0-1.412-.587T2 16v-2q0-.525.263-.987T3 12.275l.075-1.325q.2-1.7.988-3.15t1.975-2.525T8.762 3.6T12 3t3.225.6t2.725 1.663t1.975 2.512t1 3.15l.075 1.3q.475.225.738.675t.262.95v2.3q0 .5-.262.95t-.738.675V19q0 .825-.587 1.413T19 21zm-3.713-7.287Q8 13.425 8 13t.288-.712T9 12t.713.288T10 13t-.288.713T9 14t-.712-.288m6 0Q14 13.426 14 13t.288-.712T15 12t.713.288T16 13t-.288.713T15 14t-.712-.288M6.025 12.45Q5.85 9.8 7.625 7.9T12.05 6q2.225 0 3.913 1.413T18 11.025Q15.725 11 13.813 9.8t-2.938-3.25q-.4 2-1.687 3.563T6.025 12.45" />
    </svg>
  ),
  aibot: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="h-5 w-5 shrink-0" aria-hidden="true">
      <g fill="none" stroke="currentColor" strokeWidth="1.5">
        <path strokeLinejoin="round" d="M11 8h2c2.828 0 4.243 0 5.121.879C19 9.757 19 11.172 19 14s0 4.243-.879 5.121C17.243 20 15.828 20 13 20h-1s-.5 2-4 2c0 0 1-1.009 1-2.017c-1.553-.047-2.48-.22-3.121-.862C5 18.243 5 16.828 5 14s0-4.243.879-5.121C6.757 8 8.172 8 11 8Zm8 3.5h.5c.935 0 1.402 0 1.75.201a1.5 1.5 0 0 1 .549.549c.201.348.201.815.201 1.75s0 1.402-.201 1.75a1.5 1.5 0 0 1-.549.549c-.348.201-.815.201-1.75.201H19m-14-5h-.5c-.935 0-1.402 0-1.75.201a1.5 1.5 0 0 0-.549.549C2 12.598 2 13.065 2 14s0 1.402.201 1.75a1.5 1.5 0 0 0 .549.549c.348.201.815.201 1.75.201H5" />
        <path d="M13.5 3.5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0Z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 5v3m-3 4v1m6-1v1" />
        <path strokeLinecap="round" d="M10 16.5s.667.5 2 .5s2-.5 2-.5" />
      </g>
    </svg>
  ),
  webhook: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="h-5 w-5 shrink-0" aria-hidden="true">
      <path fill="currentColor" d="M7 21q-2.075 0-3.537-1.463T2 16q0-1.4.675-2.537t1.8-1.788q.525-.3 1.025.013t.5.862q0 .275-.112.5t-.313.325q-.7.375-1.137 1.075T4 16q0 1.25.875 2.125T7 19t2.125-.875T10 16q0-.425.238-.712T10.9 15h4.975q.2-.225.488-.363T17 14.5q.625 0 1.063.438T18.5 16t-.437 1.063T17 17.5q-.35 0-.638-.137T15.876 17H11.9q-.35 1.725-1.713 2.863T7 21m0-3.5q-.625 0-1.062-.437T5.5 16q0-.55.35-.95t.85-.525l2.35-3.9q-.725-.675-1.138-1.612T7.5 7q0-2.075 1.463-3.537T12.5 2q1.75 0 3.088 1.063T17.35 5.75q.125.475-.175.863t-.8.387q-.325 0-.612-.238t-.388-.587q-.275-.95-1.05-1.562T12.5 4q-1.25 0-2.125.875T9.5 7q0 .825.413 1.513T10.974 9.6q.35.2.438.5t-.088.6l-2.9 4.85q.05.125.063.225T8.5 16q0 .625-.437 1.063T7 17.5M17 21q-.65 0-1.263-.162T14.6 20.4q-.675-.375-.537-1.137t1.012-.763q.125 0 .275.05t.275.125q.325.175.663.25T17 19q1.25 0 2.125-.875T20 16t-.875-2.125T17 13q-.25 0-.475.038t-.45.112q-.4.125-.75.013t-.525-.388l-2.575-4.3q-.525-.1-.875-.5T11 7q0-.625.438-1.062T12.5 5.5t1.063.438T14 7v.213q0 .087-.05.212l2.175 3.65q.2-.05.425-.062T17 11q2.075 0 3.538 1.463T22 16t-1.463 3.538T17 21" />
    </svg>
  ),
  analytics: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="h-5 w-5 shrink-0" aria-hidden="true">
      <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
        <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" />
        <path d="M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2m0 12v-5m3 5v-1m3 1v-3" />
      </g>
    </svg>
  ),
}

const CAPABILITIES = [
  {
    id: 'workspace',
    title: 'Workspace Onboarding',
    body: 'Automate the creation of workspaces, teams, and user invitations via structured commands.',
  },
  {
    id: 'broadcast',
    title: 'Broadcast Campaigns',
    body: 'Schedule and manage bulk messaging campaigns with dynamic template variables.',
  },
  {
    id: 'livechat',
    title: 'Live Chat Operations',
    body: 'Route incoming messages, assign tickets to agents, and resolve conversations programmatically.',
  },
  {
    id: 'aibot',
    title: 'AI Bot Management',
    body: 'Deploy and configure auto-responders and chatbot flows directly from your repository.',
  },
  {
    id: 'webhook',
    title: 'Webhook & Integrations',
    body: 'Set up event listeners and connect WhatsApp activity to your external systems.',
  },
  {
    id: 'analytics',
    title: 'Analytics & Logs',
    body: 'Fetch message delivery stats, read receipts, and system health metrics on demand.',
  },
]

const VibeCodePage = () => {
  return (
    <div className="w-full min-h-screen bg-white">
      <Navigation />

      <main>
        {/* ── Hero ─────────────────────────────────────────────────────────── */}
        <section className="relative overflow-hidden bg-gradient-to-b from-white via-[#f6fbf8] to-[#dffae8]">
          {/* Dot grid */}
          <div
            className="pointer-events-none absolute inset-0"
            style={{
              backgroundImage:
                'radial-gradient(circle at 1px 1px, rgba(28,35,41,0.08) 1.1px, transparent 0)',
              backgroundSize: '22px 22px',
              maskImage:
                'linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.55) 38%, rgba(255,255,255,0.2) 70%, rgba(255,255,255,0.02) 100%)',
            }}
            aria-hidden="true"
          />
          {/* Green glow */}
          <div
            className="pointer-events-none absolute inset-0"
            style={{ background: 'radial-gradient(circle at 80% 80%, rgba(0,216,118,0.22), transparent 45%)' }}
          />

          <div className="relative mx-auto flex max-w-[1200px] flex-col items-center px-5 pb-14 pt-12 text-center sm:px-8 sm:pb-16 sm:pt-14 lg:px-[92px] lg:pb-20 lg:pt-16">
            {/* Pill */}
            <div className="flex items-center gap-2 rounded-full bg-white px-3.5 py-2 text-[10px] font-semibold uppercase tracking-[0.28px] text-[#1c2329] shadow-[inset_0px_1px_2px_rgba(26,32,50,0.08),0px_6px_16px_rgba(28,35,41,0.05)] sm:px-4 sm:text-[11px]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                className="h-4 w-4 sm:h-5 sm:w-5"
                aria-hidden="true"
              >
                <path
                  fill="#01cd74"
                  d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8m3.5-9.5-4 4a1 1 0 0 1-1.42 0l-2-2a1 1 0 0 1 1.42-1.42L11 12.59l3.09-3.09a1 1 0 0 1 1.41 1.41z"
                />
              </svg>
              <span>Agent Skills · Open Standard</span>
            </div>

            {/* Heading */}
            <h1
              className="mt-6 max-w-4xl text-[32px] font-semibold leading-[1.12] tracking-[-1px] text-[#1c2329] sm:text-[40px] sm:leading-[1.1] sm:tracking-[-1.1px] md:text-[52px] md:leading-[1.08] md:tracking-[-1.2px]"
            >
              Vibe Code{' '}
              <span style={{ color: '#00c86b' }}>WhatsApp</span>{' '}
              Automation
            </h1>

            {/* Subtitle */}
            <p className="mt-4 max-w-2xl text-[14px] leading-[1.7] tracking-[-0.3px] text-[#4b5650] sm:text-[17px] sm:leading-[1.7] sm:tracking-[-0.4px]">
              Point any AI coding agent at Notifyer&apos;s Agent Skills and let it configure, automate,
              and operate your WhatsApp Business workspace — no browser required.
            </p>

            {/* CTAs */}
            <div className="mt-8 flex w-full max-w-sm flex-col items-stretch gap-3 sm:max-w-none sm:flex-row sm:flex-wrap sm:items-center sm:justify-center sm:gap-3">
              <a
                href={GITHUB_SKILLS}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex h-11 items-center justify-center gap-2 rounded-full border-2 border-[#1c2329] px-6 text-[14px] font-semibold tracking-[-0.4px] text-[#1c2329] shadow-[0px_3px_8px_rgba(36,196,211,0.12)] transition duration-150 hover:-translate-y-0.5 hover:bg-[#f8faf9] sm:text-[15px]"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  className="h-5 w-5 shrink-0"
                  aria-hidden="true"
                >
                  <path
                    fill="currentColor"
                    d="M12 2A10 10 0 0 0 2 12c0 4.42 2.87 8.17 6.84 9.5c.5.08.66-.23.66-.5v-1.69c-2.77.6-3.36-1.34-3.36-1.34c-.46-1.16-1.11-1.47-1.11-1.47c-.91-.62.07-.6.07-.6c1 .07 1.53 1.03 1.53 1.03c.87 1.52 2.34 1.07 2.91.83c.09-.65.35-1.09.63-1.34c-2.22-.25-4.55-1.11-4.55-4.92c0-1.11.38-2 1.03-2.71c-.1-.25-.45-1.29.1-2.64c0 0 .84-.27 2.75 1.02c.79-.22 1.65-.33 2.5-.33s1.71.11 2.5.33c1.91-1.29 2.75-1.02 2.75-1.02c.55 1.35.2 2.39.1 2.64c.65.71 1.03 1.6 1.03 2.71c0 3.82-2.34 4.66-4.57 4.91c.36.31.69.92.69 1.85V21c0 .27.16.59.67.5C19.14 20.16 22 16.42 22 12A10 10 0 0 0 12 2"
                  />
                </svg>
                View on GitHub
              </a>
              <a
                href={DOCS_AGENT_SKILLS_OVERVIEW}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex h-11 items-center justify-center gap-2 rounded-full border border-[rgba(28,35,41,0.2)] bg-white px-6 text-[14px] font-semibold tracking-[-0.4px] text-[#1c2329] shadow-[0px_2px_6px_rgba(0,0,0,0.06)] transition duration-150 hover:-translate-y-0.5 hover:border-[rgba(28,35,41,0.3)] sm:text-[15px]"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 512 512"
                  className="h-5 w-5 shrink-0"
                  aria-hidden="true"
                >
                  <path
                    fill="currentColor"
                    d="M202.24 74C166.11 56.75 115.61 48.3 48 48a31.36 31.36 0 0 0-17.92 5.33A32 32 0 0 0 16 79.9V366c0 19.34 13.76 33.93 32 33.93c71.07 0 142.36 6.64 185.06 47a4.11 4.11 0 0 0 6.94-3V106.82a15.9 15.9 0 0 0-5.46-12A143 143 0 0 0 202.24 74m279.68-20.7A31.33 31.33 0 0 0 464 48c-67.61.3-118.11 8.71-154.24 26a143.3 143.3 0 0 0-32.31 20.78a15.93 15.93 0 0 0-5.45 12v337.13a3.93 3.93 0 0 0 6.68 2.81c25.67-25.5 70.72-46.82 185.36-46.81a32 32 0 0 0 32-32v-288a32 32 0 0 0-14.12-26.61"
                  />
                </svg>
                View Documentation
              </a>
              <a
                href={NOTIFYER_SIGNUP}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex h-11 items-center justify-center gap-2 rounded-full bg-[#0f1922] px-6 text-[14px] font-semibold tracking-[-0.4px] text-white shadow-[0px_10px_28px_rgba(15,25,34,0.25)] transition duration-150 hover:-translate-y-0.5 hover:bg-[#0b131a] sm:text-[15px]"
              >
                <img
                  src="/apps-logo/notifyer-system.svg"
                  alt=""
                  width="20"
                  height="20"
                  className="h-5 w-5 shrink-0 object-contain"
                  loading="eager"
                />
                Get Notifyer Free
              </a>
            </div>

            {/* Agent marquee */}
            <div className="mt-10 flex w-full flex-col items-center gap-2.5">
              <span className="text-[11px] font-semibold uppercase tracking-[0.28px] text-[#656f68]">
                Works with your agent
              </span>
              <div
                className="vc-marquee relative w-full max-w-2xl"
                role="region"
                aria-label="AI coding agents compatible with Notifyer Agent Skills"
              >
                <div className="vc-marquee-track">
                  <div className="vc-marquee-group">
                    {VIBE_AGENTS.map((a) => (
                      <AgentChip key={`g1-${a.agentId}`} agentId={a.agentId} label={a.label} />
                    ))}
                  </div>
                  <div className="vc-marquee-group" aria-hidden="true">
                    {VIBE_AGENTS.map((a) => (
                      <AgentChip key={`g2-${a.agentId}`} agentId={a.agentId} label={a.label} />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ── What Are Agent Skills ─────────────────────────────────────────── */}
        <section className="bg-white px-4 py-14 sm:px-6 sm:py-16 lg:px-16 lg:py-20">
          <div className="mx-auto max-w-screen-xl">
            <div className="mb-10 text-center sm:mb-12">
              <h2 className="text-[24px] font-semibold leading-[1.1] tracking-[-0.8px] text-[#1c2329] sm:text-[32px] sm:tracking-[-1px] md:text-[40px]">
                What are{' '}
                <span style={{ color: '#00c86b' }}>Agent Skills</span>?
              </h2>
              <p className="mx-auto mt-3 max-w-2xl text-[14px] leading-[1.6] tracking-[-0.3px] text-[#656f68] sm:text-[16px] sm:tracking-[-0.4px]">
                Structured, predictable interfaces designed specifically for AI models to understand
                and execute tasks without human intervention.
              </p>
            </div>

            <div className="w-full rounded-2xl border border-[#f2f3f3] bg-[#fafaf9] p-2 sm:p-3 md:p-4">
              <div className="grid grid-cols-1 gap-3 sm:gap-4 md:grid-cols-3 md:gap-5">
                {[
                  {
                    id: 'readable',
                    title: 'Agent-readable format',
                    body: 'Skills teach AI agents how to authenticate and operate Notifyer via structured SKILL.md files — no docs browsing needed.',
                    icon: (
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 16 16" className="h-6 w-6 shrink-0 text-[#01cd74]" aria-hidden="true">
                        <path fill="currentColor" fillRule="evenodd" d="M12 3.5H4A1.5 1.5 0 0 0 2.5 5v6A1.5 1.5 0 0 0 4 12.5h8a1.5 1.5 0 0 0 1.5-1.5V5A1.5 1.5 0 0 0 12 3.5M4 2a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3zm.47 8.53a.75.75 0 0 1 0-1.06L5.94 8L4.47 6.53a.75.75 0 0 1 1.06-1.06l2 2a.75.75 0 0 1 0 1.06l-2 2a.75.75 0 0 1-1.06 0M8.75 9.5a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5z" clipRule="evenodd" />
                      </svg>
                    ),
                  },
                  {
                    id: 'zerodeps',
                    title: 'Zero dependencies',
                    body: 'Pure Node.js 18+. Native fetch. No npm installs required. Clone and run.',
                    icon: (
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="h-6 w-6 shrink-0 text-[#01cd74]" aria-hidden="true">
                        <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 7h3a1 1 0 0 0 1-1V5a2 2 0 0 1 4 0v1a1 1 0 0 0 1 1h3a1 1 0 0 1 1 1v3a1 1 0 0 0 1 1h1a2 2 0 0 1 0 4h-1a1 1 0 0 0-1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-1a2 2 0 0 0-4 0v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h1a2 2 0 0 0 0-4H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1" />
                      </svg>
                    ),
                  },
                  {
                    id: 'phases',
                    title: '57 scripts, 3 skill phases',
                    body: 'setup-notifyer, automate-notifyer, and chat-notifyer cover the full WhatsApp Business lifecycle.',
                    icon: (
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="h-6 w-6 shrink-0 text-[#01cd74]" aria-hidden="true">
                        <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z" />
                      </svg>
                    ),
                  },
                ].map((card) => (
                  <div
                    key={card.id}
                    className="rounded-xl border border-[#f3f3f2] bg-white p-5 text-left shadow-[0px_1px_3px_rgba(0,0,0,0.04)] transition duration-200 hover:-translate-y-0.5 hover:shadow-[0px_4px_12px_rgba(0,0,0,0.06)] sm:p-6"
                  >
                    <div className="relative h-12 w-12 rounded-full border border-[rgba(28,35,41,0.12)]">
                      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                        {card.icon}
                      </div>
                    </div>
                    <h3 className="mt-4 text-[17px] font-semibold tracking-[-0.5px] text-[#1c2329] sm:text-[18px]">
                      {card.title}
                    </h3>
                    <p className="mt-2 text-[14px] leading-[1.5] text-[#656f68] sm:text-[15px] sm:leading-[1.6]">
                      {card.body}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* ── Get Started in 4 Steps ────────────────────────────────────────── */}
        <section className="px-4 py-14 sm:px-6 sm:py-16 lg:px-16 lg:py-20" style={{ background: 'linear-gradient(180deg, #f6fbf8 0%, #ffffff 60%, #f6fbf8 100%)' }}>
          <div className="mx-auto max-w-4xl">
            <h2 className="mb-10 text-center text-[24px] font-semibold leading-[1.1] tracking-[-0.8px] text-[#1c2329] sm:mb-12 sm:text-[32px] sm:tracking-[-1px] md:text-[40px]">
              Get started in{' '}
              <span style={{ color: '#00c86b' }}>4 steps</span>
            </h2>
            <ol className="space-y-4 sm:space-y-5" role="list">
              <StepCard
                number={1}
                title="Install the Agent Skills"
                description={
                  <>
                    Pulls all three skill phases —{' '}
                    <strong className="font-medium text-[#1c2329]">setup-notifyer</strong>,{' '}
                    <strong className="font-medium text-[#1c2329]">automate-notifyer</strong>, and{' '}
                    <strong className="font-medium text-[#1c2329]">chat-notifyer</strong> — into your
                    project in one command. Requires Node.js 18+; zero npm dependencies.
                  </>
                }
                code="npx skills add whatsable/whatsapp-business-agent-skills --all"
              />
              <StepCard
                number={2}
                title="Set the API base URL"
                description="Points the skills at the Notifyer API host. Required before running any script — all scripts enforce HTTPS at startup and exit immediately if this variable is missing or uses plain HTTP."
                code={`export NOTIFYER_API_BASE_URL="https://api.insightssystem.com"`}
              />
              <StepCard
                number={3}
                title="Log in & export your token"
                description={
                  <>
                    Authenticates with your Notifyer account and captures the JWT. The same token works
                    across all three skill phases — re-run this if any script returns{' '}
                    <code className="rounded bg-slate-100 px-1 py-0.5 font-mono text-xs text-slate-700">
                      HTTP 401
                    </code>
                    .
                  </>
                }
                code={STEP3_CODE}
              />
              <StepCard
                number={4}
                title="Run a health check, then prompt"
                description={
                  <>
                    <code className="rounded bg-slate-100 px-1 py-0.5 font-mono text-xs text-slate-700">
                      doctor.js
                    </code>{' '}
                    validates your token, WhatsApp connection, and plan status in one shot — run it
                    whenever a script fails unexpectedly. Then give your agent a natural-language goal and
                    it handles the rest.
                  </>
                }
                code="node skills/setup-notifyer/scripts/doctor.js --pretty"
                extra={
                  <div className="flex items-start gap-3 rounded-xl border border-[rgba(1,205,116,0.25)] bg-[#f0fdf6] px-4 py-3.5">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="mt-0.5 h-4 w-4 shrink-0 text-[#01cd74]" fill="currentColor" aria-hidden="true">
                      <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2" />
                    </svg>
                    <div>
                      <p className="text-[11px] font-semibold uppercase tracking-wide text-[#00a85d] mb-0.5">
                        Example agent prompt
                      </p>
                      <p className="text-[13px] leading-relaxed text-[#1c2329]">
                        &ldquo;Set up a Notifyer workspace for Acme Corp with a Sales team of 3 agents, create
                        a broadcast template, and give me the API key for Make.&rdquo;
                      </p>
                    </div>
                  </div>
                }
              />
            </ol>
          </div>
        </section>

        {/* ── What Your Agent Can Do ────────────────────────────────────────── */}
        <section className="bg-white px-4 py-14 sm:px-6 sm:py-16 lg:px-16 lg:py-20">
          <div className="mx-auto max-w-screen-xl">
            <h2 className="mb-10 text-center text-[24px] font-semibold leading-[1.1] tracking-[-0.8px] text-[#1c2329] sm:mb-12 sm:text-[32px] sm:tracking-[-1px] md:text-[40px]">
              What your agent can{' '}
              <span style={{ color: '#00c86b' }}>do</span>
            </h2>
            <div className="w-full rounded-2xl border border-[#f2f3f3] bg-[#fafaf9] p-2 sm:p-3 md:p-4">
              <div className="grid grid-cols-1 gap-3 sm:gap-4 md:grid-cols-2 md:gap-4 lg:grid-cols-3 lg:gap-4">
                {CAPABILITIES.map((item) => (
                  <div
                    key={item.id}
                    className="flex items-start gap-3.5 rounded-xl border border-[#f3f3f2] bg-white p-4 text-left shadow-[0px_1px_3px_rgba(0,0,0,0.04)] transition duration-150 hover:-translate-y-0.5 hover:shadow-[0px_4px_12px_rgba(0,0,0,0.06)] sm:p-5"
                  >
                    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-[rgba(28,35,41,0.12)] text-[#01cd74]">
                      {CAPABILITY_ICONS[item.id]}
                    </div>
                    <div className="min-w-0">
                      <h3 className="text-[15px] font-semibold tracking-[-0.4px] text-[#1c2329] sm:text-[16px]">
                        {item.title}
                      </h3>
                      <p className="mt-1 text-[13px] leading-[1.5] text-[#656f68] sm:text-[14px] sm:leading-[1.6]">
                        {item.body}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* ── Bottom CTA ───────────────────────────────────────────────────── */}
        <section className="bg-white px-4 py-10 sm:px-8 sm:py-12 lg:px-[100px] lg:py-16">
          <div className="mx-auto max-w-[1240px] rounded-[18px] border border-[#ececec] bg-[#fafaf9] p-2">
            <div
              className="relative overflow-hidden rounded-[14px] px-6 py-12 sm:px-10 lg:px-16 lg:py-16"
              style={{ backgroundColor: '#0b0f14' }}
            >
              {/* Dot grid on dark */}
              <div
                className="pointer-events-none absolute inset-0"
                style={{
                  backgroundImage:
                    'radial-gradient(circle at 1px 1px, rgba(255,255,255,0.04) 1px, transparent 0)',
                  backgroundSize: '24px 24px',
                }}
                aria-hidden="true"
              />
              {/* Green glow */}
              <div
                className="pointer-events-none absolute inset-0"
                style={{ background: 'radial-gradient(circle at 30% 70%, rgba(1,205,116,0.12), transparent 55%)' }}
                aria-hidden="true"
              />

              <div className="relative flex flex-col items-center gap-5 text-center text-white">
                <h2 className="text-[28px] font-semibold leading-tight tracking-[-1px] sm:text-[36px] lg:text-[44px]">
                  <span style={{ color: '#01cd74' }}>Ready to automate</span>
                  <br className="hidden sm:block" />
                  WhatsApp with your AI agent?
                </h2>
                <p className="max-w-2xl text-[15px] leading-[1.7] tracking-[-0.4px] text-[#e7f0ec] sm:text-[16px]">
                  Open the repo, install the skills, and ship automation directly from your editor —
                  no browser required.
                </p>
                <div className="flex flex-col items-center gap-3 sm:flex-row sm:flex-wrap sm:justify-center sm:gap-4">
                  <a
                    href={GITHUB_SKILLS}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex h-12 items-center justify-center gap-2 rounded-full bg-[#01cd74] px-8 text-[14px] font-semibold tracking-[-0.4px] text-[#0f1b14] shadow-[0px_4px_10px_rgba(1,205,116,0.35)] transition duration-150 hover:-translate-y-0.5 sm:text-[15px]"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      className="h-5 w-5 shrink-0"
                      aria-hidden="true"
                    >
                      <path
                        fill="currentColor"
                        d="M12 2A10 10 0 0 0 2 12c0 4.42 2.87 8.17 6.84 9.5c.5.08.66-.23.66-.5v-1.69c-2.77.6-3.36-1.34-3.36-1.34c-.46-1.16-1.11-1.47-1.11-1.47c-.91-.62.07-.6.07-.6c1 .07 1.53 1.03 1.53 1.03c.87 1.52 2.34 1.07 2.91.83c.09-.65.35-1.09.63-1.34c-2.22-.25-4.55-1.11-4.55-4.92c0-1.11.38-2 1.03-2.71c-.1-.25-.45-1.29.1-2.64c0 0 .84-.27 2.75 1.02c.79-.22 1.65-.33 2.5-.33s1.71.11 2.5.33c1.91-1.29 2.75-1.02 2.75-1.02c.55 1.35.2 2.39.1 2.64c.65.71 1.03 1.6 1.03 2.71c0 3.82-2.34 4.66-4.57 4.91c.36.31.69.92.69 1.85V21c0 .27.16.59.67.5C19.14 20.16 22 16.42 22 12A10 10 0 0 0 12 2"
                      />
                    </svg>
                    View Agent Skills on GitHub
                  </a>
                  <a
                    href={DOCS_AGENT_SKILLS_OVERVIEW}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex h-12 items-center justify-center gap-2 rounded-full border border-white/20 bg-white/10 px-7 text-[14px] font-semibold tracking-[-0.4px] text-white transition duration-150 hover:-translate-y-0.5 hover:bg-white/15 sm:text-[15px]"
                  >
                    View Documentation
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  )
}

export default VibeCodePage

